import { render, staticRenderFns } from "./RecommendSecond.vue?vue&type=template&id=1840bd87&scoped=true&"
import script from "./RecommendSecond.vue?vue&type=script&lang=js&"
export * from "./RecommendSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840bd87",
  null
  
)

export default component.exports